import React from 'react'
import { Input, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { toast } from 'react-toastify';
import { useLetterBoxFilter } from '../../../../../Features/letterBox/context/FilterContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { readAllLetters, reloadLetterBox } from '../../../../../Features/letterBox/api/letterBox.api';

type MailBodyProps = {
    unreadCount: number;
    selectedIds: number[];
    onDeleteIds: (ids: number[]) => void;
    isDeleting: boolean;
};

export default function MailBody({ selectedIds, onDeleteIds, isDeleting, unreadCount }: MailBodyProps) {
    const { filters, setSearch, setUnreadOnly } = useLetterBoxFilter();
    const queryClient = useQueryClient();
    const readAllMutation = useMutation({
        mutationFn: readAllLetters,
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ['letterBox-list'] });
            toast.success('Email segnate come lette.');
        },
        onError: (error: Error) => toast.error(error.message || 'Impossibile segnare le email come lette.'),
    });
    const reloadMutation = useMutation({
        mutationFn: () => reloadLetterBox(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["letterBox-list"], exact: false });
        }
    });

    const handleSearch = (value: string) => {
        setSearch(value || undefined);
        queryClient.invalidateQueries({ queryKey: ["letterBox-list"], exact: false });
    };

    const handleDeleteSelected = () => {
        if (!selectedIds.length || isDeleting) return;
        const confirmed = window.confirm("Confermi l'eliminazione delle email selezionate?");
        if (!confirmed) return;
        onDeleteIds(selectedIds);
    };

    return (
        <div className="mail-body">
            <div className="mail-search d-flex-align-items-center">
                <Input
                  type="text"
                  placeholder="Cerca..."
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <i className="fa-solid fa-magnifying-glass" />
            </div>
            <div className="d-flex align-items-center gap-1">
            <button
                type="button"
                style={{height:'100%'}}
                className={`btn btn-sm ${filters.new === 1 ? 'btn-primary' : 'btn-outline-primary'} text-nowrap`}
                aria-pressed={filters.new === 1}
                title="Email da leggere nella lista caricata, incluse le risposte"
                onClick={() => setUnreadOnly(filters.new !== 1)}
            >
                Da leggere: {unreadCount}
            </button>
            <UncontrolledDropdown>
                <DropdownToggle type="button" color="transparent" className="light-square border-0" aria-label="Altre azioni email">
                    <i className="fa-solid fa-ellipsis-vertical" aria-hidden="true" />
                </DropdownToggle>
                <DropdownMenu end>
                    <DropdownItem disabled={readAllMutation.isPending} onClick={() => { if (!readAllMutation.isPending) readAllMutation.mutate(); }}>
                        {readAllMutation.isPending ? 'Lettura in corso...' : 'Leggi tutti'}
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
            </div>
            <div
              className="light-square"
              onClick={() => reloadMutation.mutate()}
              role="button"
              aria-label="Reload mail list"
            >
                <i className={`fa-solid fa-arrows-rotate ${reloadMutation.isPending ? "fa-spin" : ""}`} />
            </div>

            <div
              className="light-square"
              role="button"
              aria-label="Delete selected mail"
              onClick={handleDeleteSelected}
            >
                <i className={`fa-solid fa-trash ${isDeleting ? "fa-spin" : ""}`} />
            </div>

            {/* <div className="light-square"><i className="fa-solid fa-trash" /></div>
            <Dropdown isOpen={openDrop} toggle={toggle}>
                <DropdownToggle color="transparent" dir="left" className="light-square">
                    <i className="fa-solid fa-ellipsis-vertical" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-block" end={true}>
                    {mailBodyItems.map((item, index) => (
                        <DropdownItem href={Href} key={index}>{item}</DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown> */}
        </div>
    )
}
